import { Modal, ModalProps, modalHoc } from '@innowise-group/mui-kit';
import { useTranslation } from 'react-i18next';
import * as Styled from './closure-referral-payment';
import { ClosureReferralPaymentModalProps } from './closure-referral-payment.types';

const ClosureReferralPaymentModal: React.FC<ModalProps & ClosureReferralPaymentModalProps> = ({
  title,
  titleParams,
  description,
  confirmationText,
  close,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const onCloseHandler = () => {
    close();
  };

  return (
    <Modal.Container size="small">
      <Modal.Header onClose={onCloseHandler}>
        <Styled.Header>{t(title, titleParams)}</Styled.Header>
      </Modal.Header>
      <Modal.Body>
        <Styled.Description>{t(description)}</Styled.Description>
      </Modal.Body>
      <Modal.Actions
        noVerticalPadding={true}
        position={'full'}
        actions={[
          {
            title: t('buttons.cancel'),
            onClick: onCloseHandler,
            type: 'button',
          },
          {
            title: t(confirmationText),
            onClick: onSubmit,
            type: 'button',
            highlighted: true,
          },
        ]}
      />
    </Modal.Container>
  );
};

export default modalHoc(ClosureReferralPaymentModal, 'closure-referral-payment');
